import React from 'react';
import { Route, Routes } from 'react-router-dom';
import WelcomeTopic from './topics/start';
import TopicFrameworks from './topics/frameworks';
import TopicCore from './topics/core';
import TopicData from './topics/data';
import TopicAi from './topics/ai';
import TopicSe from './topics/se';
import TopicThirdParty from './topics/thirdparty';
import TopicIncident from './topics/incident';
import TopicQuiz from './topics/topicQuiz';
import './index.less';
import './index.mobile.less';
import './index.en.less';

export interface ICivilProps {
  topicName: string;
  topicSettings: any;
}

export function Civil(props: ICivilProps) {
  return (
    <Routes key={props.topicName}>
      <Route
        path="/"
        element={<WelcomeTopic settings={props.topicSettings} />}
      />
      <Route
        path="/welcome"
        element={<WelcomeTopic settings={props.topicSettings} />}
      />
      <Route
        path="/frameworks"
        element={<TopicFrameworks settings={props.topicSettings} />}
      />
      <Route
        path="/core"
        element={<TopicCore settings={props.topicSettings} />}
      />
      <Route
        path="/data"
        element={<TopicData settings={props.topicSettings} />}
      />
      <Route path="/ai" element={<TopicAi settings={props.topicSettings} />} />
      <Route path="/se" element={<TopicSe settings={props.topicSettings} />} />
      <Route
        path="/thirdparty"
        element={<TopicThirdParty settings={props.topicSettings} />}
      />
      <Route
        path="/incident"
        element={<TopicIncident settings={props.topicSettings} />}
      />
      <Route
        path="/quiz"
        element={<TopicQuiz settings={props.topicSettings} />}
      />
    </Routes>
  );
}
